import { X } from 'lucide-react'
import { ACCOUNT_PAGES_HERO_IMAGE_URL } from '../constants/accountPagesHeroImage'

/**
 * Shown when the user completes the last welcome pack topic (via “Finish welcome pack”).
 */
const ReserveWelcomePackCompleteModal = ({
  isOpen,
  onClose,
  onContinueToStart,
  onGoToGuide,
}) => {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4 backdrop-blur-[2px] sm:p-6"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-lg overflow-hidden rounded-2xl border border-white/10 bg-white shadow-[0_25px_60px_-15px_rgba(0,0,0,0.35)]"
        role="dialog"
        aria-modal="true"
        aria-labelledby="reserve-welcome-complete-title"
        aria-describedby="reserve-welcome-complete-desc"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative h-44 bg-neutral-900 sm:h-52">
          <img
            src={ACCOUNT_PAGES_HERO_IMAGE_URL}
            alt=""
            className="h-full w-full object-cover opacity-95"
            decoding="async"
          />
          <div
            className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/35 to-black/20"
            aria-hidden
          />
          <button
            type="button"
            onClick={onClose}
            className="absolute right-3 top-3 z-10 rounded-full bg-black/35 p-2 text-white backdrop-blur-sm transition hover:bg-black/50"
            aria-label="Close"
          >
            <X className="h-5 w-5" aria-hidden />
          </button>
          <div className="absolute inset-x-0 bottom-0 px-6 pb-5 pt-8 sm:px-8 sm:pb-6">
            <p className="font-poppinsLight text-[11px] font-medium uppercase tracking-[0.2em] text-white/70">
              Axonall Reserve
            </p>
            <h2
              id="reserve-welcome-complete-title"
              className="font-AXONALLPrimeSemiBold mt-1 text-2xl font-bold leading-tight tracking-tight text-white sm:text-[1.75rem]"
            >
              Thank you
            </h2>
          </div>
        </div>

        <div className="px-6 pb-7 pt-6 sm:px-8 sm:pb-8">
          <p
            id="reserve-welcome-complete-desc"
            className="font-poppinsLight m-0 text-[15px] leading-relaxed text-neutral-600 sm:text-base"
          >
            Welcome to Axonall Reserve. You&apos;ve completed this welcome pack—we&apos;re glad you&apos;re here.
          </p>

          <div className="mt-7 flex flex-col gap-3">
            <button
              type="button"
              onClick={onContinueToStart}
              className="inline-flex w-full items-center justify-center rounded-xl border border-neutral-900 bg-neutral-950 px-4 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-white shadow-sm transition hover:bg-black"
            >
              Back to first topic
            </button>
            <button
              type="button"
              onClick={onGoToGuide}
              className="inline-flex w-full items-center justify-center rounded-xl border border-neutral-200 bg-white px-4 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-neutral-800 transition hover:bg-neutral-50"
            >
              Membership guide
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReserveWelcomePackCompleteModal
